import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseService} from './base.service';
import {ECatalog} from '../enums/ECatalog';
import {ECountryOrder} from '../enums/ECountryOrder';

@Injectable()
export class CatalogsService {
  constructor(private http: HttpClient, private baseService: BaseService) {
  }

  getCatalog(catalog: ECatalog, index?, order?: ECountryOrder) {
    const ind = index ? `?index=${index}` : '';
    if (catalog == ECatalog.COUNTRY) {
      return this.http.get(`/catalog/${catalog}${ind}?order=${order}`);
    }
    return this.http.get(`/catalog/${catalog}${ind}`);
  }

  getIdentificationCatalog(index, numericCode, iId?, agentMode? ) {
    const id = iId ? `&id=${iId}` : '';
    const mode = agentMode ? `&mode=${agentMode}` : '';
    return this.http.get(`/catalog/IDENTIFICATION?numericCode=${numericCode}&index=${index}${id}${mode}`);
  }

  getIdentificationContryCatalog(agentMode?) {
    const mode = agentMode ? `&mode=${agentMode}` : '';
    return this.http.get(`/catalog/COUNTRY?filter=DOCUMENTS${mode}`);
  }

  getPostalCode(postalCode) {
    return this.http.get(`/catalog/postalcode?cp=${postalCode}`);
  }

  getStates(){
    return this.http.get(`/catalog/MEXICAN_STATES`);
  }

  getPronouns(){
    return this.http.get(`/catalog/GENDER_PRONOUNS`);
  }
}
